<template>
    <div class="container">
    <Navbar />
    <div class="bg-image"></div>
    <div class="bg-tint"></div>
        <div id="login">
            <label for="username">Käyttäjätunnus: </label>
            <input type="text" name="username" id="username" v-model="username"><br>
            <label for="password">Salasana: </label>
            <input type="password" name="password" id="password" v-model="password"><br>
            <button id="loginButton" @click="login">Kirjaudu</button>
            <router-link to="/register" id="register">REKISTERÖIDY</router-link>
        </div>
    </div>
</template>

<script>
import userService from '../services/user.js';
import { ref } from 'vue';
import Navbar from './Navbar.vue';
import { useStore } from 'vuex'
import jwt from 'jsonwebtoken';

export default {
    name: 'Login',
    components: {
        Navbar
    },
    setup() {
        const username = ref('');
        const password = ref('');
        const store = useStore();

        const login = async () => {
            const credentials = { username: username.value, password: password.value };
            // Post username and password to backend
            const response = await userService.processCredentials(credentials, 'login');

            // If login is successful, jwt token should have been sent from backend and saved to cookie
            if (response.token) {
                document.cookie=`token=${response.token}`;
                const decodedToken = jwt.decode(response.token);
                store.commit('setLoggedUser', decodedToken.username);
            }
            else
                console.log('Ei tokenia');
        }

        return { username, password, login };
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
nav {
  display: flex;
  background-color: #444444;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 8%;
  overflow: hidden;
  z-index: 100;
  justify-content: center;
  border-bottom: 0.7vh solid #76B2BA;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

nav > img {
  height: 70%;
  margin: auto;
}

nav > a {
  color: white;
  text-decoration: none;
  padding: 1em 3em;
  margin: 0 0.1em;
  width: 10em;
  font-size: 1em;
}

nav > a:hover {
  color: #48a3a7;
}

.container {
  height: 95vh;
}

.bg-image {
  background-image: url('../assets/start_bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 95vh;
  filter: blur(3px);
  z-index: 0;
}

.bg-tint {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #76B2BA;
  opacity: 0.4;
  z-index: 1;
}

#login {
  position: fixed;
  top: 10%;
  right: 10%;
  left: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 70vh;
  z-index: 50;
}

#login label {
  font-size: 20px;
}

input {
    padding: 11px 120px;
    margin: 5px;
    text-align: center;
}

#register {
    color: black;
    font-size: 13px;
    margin-top: 2em;
}

</style>
